import { Box } from "@mui/material";
import React, { useState } from "react";
import DefineGarmentSection from "../../../components/features/Pipelines/DefineGarmentSection";
import PipelineDetails from "../../../components/features/Pipelines/PipelineDetails";
import JobConfigurationSection from "../../../components/features/Pipelines/JobConfigurationSection";
import { JobConfigurationProvider } from "../../../contexts/JobConfigurationContext";
import { usePipelineContext } from "../../../contexts/PipelineContext";

function PipelineGeneralConfiguration() {
  const { orderedJobs, addJob, updateJob, removeJob, setOrderedJobs } = usePipelineContext();
  const [activeJob, setActiveJob] = useState(null);
  const [unsavedChanges, setUnsavedChanges] = useState(false);

  const handleJobUpdate = (updatedJob) => {
    console.log("updatedJob", updatedJob);
    updateJob(updatedJob.id, updatedJob);
    setUnsavedChanges(true);
    setActiveJob(null);
    console.log(`orderedJobs: ${JSON.stringify(orderedJobs)}`)
  };

  const handleJobRemove = (jobId) => {
    removeJob(jobId);
    setUnsavedChanges(true);
  };

  return (
    <JobConfigurationProvider
      activeJob={activeJob}
      setActiveJob={setActiveJob}
      setUnsavedChanges={setUnsavedChanges}
      unsavedChanges={unsavedChanges}
      handleJobUpdate={handleJobUpdate}
    >
    <Box
      sx={{
        height: "100%",
        width: "100%",
        display: "flex",
        flexDirection: "row",
        mt: -1
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flex: 1,
          flexDirection: "column",
        }}
      >
          <PipelineDetails userTableHeight={"30vh"} /> {/* jobConfigurationSection={
            <JobConfigurationSection   
            handleJobUpdate={handleJobUpdate}
            setOrderedJobs={setOrderedJobs}
            orderedJobs={orderedJobs}
            addJob={addJob}
            handleJobRemove={handleJobRemove}/>
            } */}
      </Box>
      <Box
        sx={{
          height: "100%",
          width: "100%",
          display: "flex",
          flex: 2,
          mt: -1,
          flexDirection: "column",
        }}
      >
        <JobConfigurationSection   
          handleJobUpdate={handleJobUpdate}
          setOrderedJobs={setOrderedJobs}
          orderedJobs={orderedJobs}
          addJob={addJob}
          handleJobRemove={handleJobRemove}/>
      </Box>
    </Box>
    </JobConfigurationProvider>
  );
}

export default PipelineGeneralConfiguration;
